export const CSRF_RELOAD_TIMEOUT = 3000;
export const SHIPPING_COST_THRESHOLD = gon.freeShippingAmount || 3400;
export const SHIPPING_COST = gon.standardShippingCost || 700;
export const SMOKER_REFERAL_DISCOUNT_CENTS = 1500;
export const DESKTOP_WIDTH = 1024;
export const CART_ICON_ANIMATION_DURATION = 500;
export const OPEN_CART_FOR_DESKTOP_BUFFER = 100;
export const AUTO_CLOSE_CART_FOR_DESKTOP_DELAY = 2000;
export const OPEN_CART_FOR_DESKTOP_DELAY =
  CART_ICON_ANIMATION_DURATION + OPEN_CART_FOR_DESKTOP_BUFFER;



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/appConstants.js